<section>
  <div>
    <div class="title-billing">
      <h1 class="center">Facturation</h1>
    </div>
    <div class="page-billing">
      <mat-grid-list cols="2" rowHeight="1.35:1" gutterSize="20px">
        <mat-grid-tile
          [class.not-calendar] = "!showCalendar()"
          matTooltip="L'accès à l'espace facturation (Lean Pay) est temporairement inaccessible. Veuillez réessayer ultérieurement"
          [matTooltipDisabled]="URL != null" class="{{URL == null ? 'disabled' : ''}}">
          <mat-icon svgIcon="leanpay" class="leanpay"></mat-icon>
          <mat-grid-tile-footer (click)="leanpay()">
            <mat-icon>forward</mat-icon>Accéder à votre espace LeanPay
          </mat-grid-tile-footer>
        </mat-grid-tile>
        <mat-grid-tile *ngIf="showCalendar()">
          <mat-icon svgIcon="calendar"></mat-icon>
          <mat-grid-tile-footer (click)="exportGlobal()">
            <mat-icon>vertical_align_bottom</mat-icon>Télécharger le calendrier de facturation
          </mat-grid-tile-footer>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
</section>